let repairOptionInstructionCols = [
    {
        key: 'id',
        display: 'Id'
    },
    {
        key: 'repairProviderId',
        display: 'Provider Id'
    },
    {
        key: 'repairProviderLabel',
        display: 'Provider Name'
    },
    {
        key: 'repairOptionTypeId',
        display: 'Type Id'
    },
    {
        key: 'repairOptionTypeLabel',
        display: 'Option Label'
    },
]

export { repairOptionInstructionCols }